import { COMPETENCY_CARD_TYPES } from 'constants/competency-card-types';

const CUSTOM_TYPE = 'CUSTOM_BUSINESS_COMPETENCY';
const CUSTOM_PREFIX = `${CUSTOM_TYPE}#`;

// A project's required competency cards are stored as encoded strings, using the
// same encoding as the add-card UI (AddCardDialogContent):
//   - standard card: the card type enum string, e.g. 'WORKSITE_CARD'
//   - business custom competency: 'CUSTOM_BUSINESS_COMPETENCY#<name>'
export const decodeRequiredCompetencyCardType = (entry) => {
  if (typeof entry !== 'string' || !entry) {
    return null;
  }

  if (entry.startsWith(CUSTOM_PREFIX)) {
    return { type: CUSTOM_TYPE, name: entry.slice(CUSTOM_PREFIX.length) };
  }

  return { type: entry, name: null };
};

// Does the user hold a valid card that satisfies a single required entry?
// Standard cards are matched by `type`; custom competencies by `name`.
export const userHasRequiredCompetencyCard = (validCards, entry) => {
  const decoded = decodeRequiredCompetencyCardType(entry);
  if (!decoded) {
    return false;
  }

  if (decoded.type === CUSTOM_TYPE) {
    return validCards.some(
      (card) => card.type === CUSTOM_TYPE && card.name === decoded.name
    );
  }

  return validCards.some((card) => card.type === decoded.type);
};

// Returns the encoded required entries the user is missing a valid card for.
export const getMissingRequiredCompetencyCardTypes = (
  validCards = [],
  requiredCardTypes = []
) =>
  requiredCardTypes.filter(
    (entry) => !userHasRequiredCompetencyCard(validCards, entry)
  );

// Human-readable label for an encoded entry. `t` is the i18next translate fn.
export const getRequiredCompetencyCardTypeLabel = (entry, t) => {
  const decoded = decodeRequiredCompetencyCardType(entry);
  if (!decoded) {
    return '';
  }

  if (decoded.type === CUSTOM_TYPE) {
    return decoded.name;
  }

  const standardCardType = COMPETENCY_CARD_TYPES[decoded.type];
  if (!standardCardType) {
    return decoded.type;
  }

  return t(`cards-and-competencies.${standardCardType.name}`);
};
